<template>
  <transition name="slide-fade">
    <div
      v-if="visible"
      class="version-toast"
    >
      <div class="margin-right-md">
        <i class="fas fa-exclamation-circle"></i>
      </div>

      <div>
        <p class="version-toast__title margin-bottom-xs">
          A new version of Producer is available
        </p>

        <p>
          Please reload to get the latest changes
        </p>

        <button
          class="tb-btn tb-btn-contained medium-em"
          data-entity="producer-versionReload"
          data-test="version-check-toast"
          @click="onClickReload"
        >
          Reload
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
/**
* Component will continuously hit /ping on the producer API and check if the hash changes.
* If the hash has changed since it's last check, a toast notification
* will show prompting the user to reload the page.
*/

// File to check for changes, should point to something like a txt file containing a hash.
// Checking the root HTML file works too, but is less optimal.
const FilePath = '/version';

const PollInterval = 30e3;

export default {
  data() {
    return {
      visible: false,
      hash: null,
    };
  },

  mounted() {
    this.checkHash();
  },

  beforeDestroy() {
    clearTimeout(this.timeout);
  },

  methods: {
    onClickReload() {
      window.location.reload();
    },

    async checkHash() {
      try {
        const resp = await fetch(FilePath);
        const data = await resp.text();

        if (!this.hash) {
          // First request, so just store hash
          this.hash = data;
        } else if (this.hash !== data) {
          // Show the toast and don't bother polling for changes anymore.
          this.hash = data;
          this.visible = true;
          return;
        }
      } catch (err) { /* noop */ }

      this.timeout = setTimeout(() => this.checkHash(), PollInterval);
    },
  },
};
</script>

<style lang="scss" scoped>
.version-toast {
  z-index: 1000;
  position: fixed;
  bottom: calc(0.5rem + 40px);
  right: 1rem;
  border-left: 4px solid #26c5da;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.14), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 1px 8px 0 rgba(0, 0, 0, 0.2);
  background: #121212;
  padding: 1rem 2rem;
  border-radius: 4px;
  display: flex;

  .fas {
    font-size: 24px;
    margin-top: 0.5rem;
  }
}

.version-toast__title {
  font-weight: bold;
  font-size: 1.1em;
}
</style>
